import { render, staticRenderFns } from "./BuQuanDanCi.vue?vue&type=template&id=cd443d5e&scoped=true"
import script from "./BuQuanDanCi.vue?vue&type=script&lang=js"
export * from "./BuQuanDanCi.vue?vue&type=script&lang=js"
import style0 from "./BuQuanDanCi.vue?vue&type=style&index=0&id=cd443d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd443d5e",
  null
  
)

export default component.exports